import "../../../../stylesheets/templates/fundraising/volunteers-form";
import "../../../../stylesheets/accounts/base";
import "../../../../stylesheets/components/forms";
import "./index";
import { formatPhoneNumber, validateFormData } from "../../../backoffice/utils";
import { applyVolunteerFieldFilters } from "../../../utils";
import { validatePhoneNumbers, validateTaxId, formatTaxIdInput } from "../../../utils";
import { addRequiredStar, checkEmailConfirmation, rutFormValidity } from "../../utils";

$(document).ready(function () {
  var disabled = false;

  // Change styles of date of birth options

  $("select").on("change", function () {
    if (this.value) {
      $(this).removeClass("placeholder");
    } else {
      $(this).addClass("placeholder");
    }
  });

  // Handle volunteers form
  $("#register-button").click((event) => {
    event.preventDefault();
    event.stopPropagation();
    // dentro del listener del submit
    if (disabled) return;
    disabled = true;
    setTimeout(() => {
      disabled = false;
    }, 1500);
    const form = $("#new_volunteer");
    form[0].classList.add("was-validated");

    // Validate terms and conditions checkbox
    const termsCheckbox = document.getElementById(
      "volunteer_terms_and_conditions_checkbox"
    );
    if (termsCheckbox && !termsCheckbox.checked) {
      alert("Debes aceptar los términos y condiciones.");
      disabled = false;
      return;
    }

    const rutField = $("#volunteer_tax_id")[0];
    const rutValidity = rutField ? validateTaxId(rutField.value, window.country_code) : true;

    if (rutValidity === false) {
      $("#volunteer_tax_id").addClass("is-invalid");
      $("#new_volunteer").removeClass("was-validated");
    }
    var validMail = $("#volunteer_email")[0]
      ? $("#volunteer_email")[0].checkValidity()
      : false;
    if (!validMail && $("#volunteer_email")[0] === undefined) validMail = true;
    formatPhoneNumber();
    let validPhoneNumbers = validatePhoneNumbers($("#new_volunteer"));
    if (
      form[0].checkValidity() === true &&
      validMail === true &&
      validPhoneNumbers &&
      checkEmailConfirmation() === true
    ) {
      grecaptcha.enterprise.ready(function () {
        grecaptcha.enterprise
          .execute(recaptcha_site_key, { action: "submit" })
          .then(function (token) {
            let captcha = $(`input[name="recaptcha_token"`);
            for (var i = 0; i < captcha.length; i++) {
              captcha[i].value = token;
            }
            form.submit();
          });
      });
    } else {
      console.log("Validation not going through");
      console.log(
        "Form checkValidity: " + (form[0].checkValidity() === true).toString()
      );
      console.log("TaxID not required: " + !$("#volunteer_tax_id").required);
      if (form[0].checkValidity() === false) {
        validateFormData(form[0]);
      }
    }
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const kindSelect = document.getElementById("volunteer-kind-select");
  const descriptionBox = document.getElementById("volunteer-kind-description");
  const customFields = document.querySelectorAll(".volunteer-custom-field");

  if (kindSelect && descriptionBox) {
    const descriptions = JSON.parse(kindSelect.dataset.descriptions || "{}");
    const updateKindDescription = () => {
      const text = descriptions[kindSelect.value] || "";
      descriptionBox.textContent = text;
      descriptionBox.style.display = text ? "block" : "none";
    };
    kindSelect.addEventListener("change", updateKindDescription);
    updateKindDescription();
  }

  if (kindSelect && customFields.length > 0) {
    kindSelect.addEventListener("change", () => {
      applyVolunteerFieldFilters(kindSelect.value, customFields);
      addRequiredStar();
    });
    applyVolunteerFieldFilters(kindSelect.value, customFields);
    addRequiredStar();
  }

  $(".tax_id_input").on("input", ({ target }) => {
    let val = formatTaxIdInput(target.value, window.country_code);
    target.value = val;
  });

  $(".tax_id_input").on("blur", ({ target }) => {
    const rutField = target;
    const rutValidity = rutField ? validateTaxId(rutField.value, window.country_code) : true;
    const formParent = $(rutField).closest("form");
    rutFormValidity(rutValidity, formParent, $(rutField));
  });
});
